import React from 'react';

class NoClassesToDisplay extends React.Component {

    render() {
        return (
            <div className="m-2">
                <p>No classes were found using your current selection.</p>
                <p>Try to add more locations, subjects, or instruction modes, or expand the date range.</p>
                <p>Do you need help finding a class? Visit one of our Virtual Offices to speak to a person!</p>
                <a href="https://umgc-edu.zoom.us/j/840013102" className="btn btn-primary">VIRTUAL OFFICE: CLICK HERE TO VISIT US 7 DAYS PER WEEK</a>
            </div>
        );
    }
}

export default NoClassesToDisplay;